<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-pen-to-square"></i></div>
      <div>
        Fiche de note
        <div class="page-title-subheading">Saisie des notes par composition</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div *ngIf="compositionId==undefined" class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-3">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <ng-select  (change)="loadCourses($event)" >
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-3">
        <label for="" class="form-label mb-0">Choisir la matière</label>
        <ng-select  (change)="loadCompositions1($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let c of courses" [value]="c?.id">{{c?.name}}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-3">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <ng-select  [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 col-md-3">
        <label for="" class="form-label mb-0">Choisir la composition</label>
        <ng-select  ngModel name="composition_id" (change)="loadNotes($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let c of compositions" [value]="c?.id">{{c?.name}}</ng-option>
        </ng-select>
      </div>
    </div>
  </div>
</div>
<div class="text-center mb-3">
    <button *ngIf="currentCompositon?.has_note && !currentCompositon.is_published" (click)="publish()" class="btn btn-sm btn-primary">Valider les notes de cette composition</button>
</div>

<div class="container bg-white p-3 table-responsive">
    <p>{{data!.length}} élément(s)</p>
    <table class="table table-sm table-bordered table-striped">
        <thead>
            <th>#</th>
            <th>Apprenant</th>
            <th>Note</th>
            <th>Statut</th>
            <th>Appréciation</th>
        </thead>
        <tbody>
            <tr *ngFor="let d of data; let i=index" >
                <td>{{i+1}}</td>
                <td><span class="text-dark h6 text-center"><strong><small>{{d.sac?.student?.lastname}} {{d.sac?.student?.firstname}}</small></strong></span></td>
                <td>{{d.is_setted? d.value : d.new_value}}</td>
                <td>
                <div *ngIf="d.is_setted">Note directe</div>
                <div *ngIf="!d.is_setted">
                        <p> {{d.motif}}</p>
                        <span class="text-primary" (click)="getFile('','compositions',d.motif_file)" style="cursor: pointer;"> Voir le fichier</span>

                </div>
                </td>
                <td> {{d.appreciation}}</td>
            </tr>
        </tbody>
    </table>
   
</div>